import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        }
    };

    return axios.get(`${url}/projects`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/projects/${id}`, options)
        .then(response => {
            let project = jsona.deserialize(response.data);
            delete project.links;
            return project;
        });
}

function add(project) {
    const payload = jsona.serialize({
        stuff: project,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/projects`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(project) {
    const payload = jsona.serialize({
        stuff: project,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/projects/${project.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/projects/${id}`, options);
}


export default {
    list,
    get,
    add,
    update,
    destroy
};

